import { useCallback } from 'react'
import { useQuery } from 'react-query'
import { OfficeUser, TeacherProfile, User } from '../../generated'
import { createSessionState, State } from '../session/state'

const skipLoad = [
  'not-found',
  'reset-passwords',
  'reset-passwords-complete',
  'password-reset-request',
  'password-reset-request-complete',
]

export function needLogin(location: string) {
  const path = location?.split('/')[2]
  if (!path) return false
  return !skipLoad.some((v) => v === path)
}

export type UseUser = () => {
  user?: User
  refetch: () => Promise<void>
  state: State
  onError: (r?: Response) => void
}

export function createUserStore(
  _load: () => Promise<User | OfficeUser | TeacherProfile>,
  _signIn: (id: string, pw: string, keep: boolean) => Promise<void>,
  _signOut: () => Promise<void>
) {
  const {
    onSignOut,
    signIn: signIn2,
    signOut,
    onError,
    useSession,
    send,
  } = createSessionState(_signIn, _signOut)

  function useUser() {
    const { data: user, refetch } = useQuery('useUser', _load, {
      onSuccess: () => send('onSuccess'),
      onError,
    })
    const state = useSession()
    const signIn = useCallback(
      async (id: string, pw: string, keep: boolean) => {
        await signIn2(id, pw, keep)
        refetch()
      },
      [refetch]
    )
    const user2 = { id: -1, ...user }

    return {
      user: user2,
      signIn,
      refetch,
      onError,
      state,
    }
  }

  return {
    signOut,
    onSignOut,
    onError,
    useUser,
  }
}
